import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import schoolApi from "../../api/schoolApi";
import { SessionContext } from "../SessionProvider";

const CreateSessionModal = (props) => {
  const { fetchSessions } = useContext(SessionContext);
  const [sessionData, setSessionData] = useState({
    startdate: "",
    enddate: "",
    year: "",
    isChange : false,
  });

  useEffect(() => {
    if (props.sessionData) {
      setSessionData({
        startdate: props.sessionData.startdate.split("T")[0],
        enddate: props.sessionData.enddate.split("T")[0],
        year: props.sessionData.year,
        isChange : false,
      });
    } else {
      setSessionData({
        startdate: "",
        enddate: "",
        year: "",
        isChange : false,
      });
    }
  }, [props.sessionData]);

  useEffect(() => {
    if (sessionData.startdate && sessionData.enddate) {
      const start = sessionData.startdate.split("-");
      const end = sessionData.enddate.split("-");
      const startYear = parseInt(start[0]);
      const endYear = parseInt(end[0]);
      const year = startYear + "-" + endYear;
      setSessionData((prevSessionData) => ({
        ...prevSessionData,
        year: year,
      }));
    }
  }, [sessionData.startdate, sessionData.enddate]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "enddate") {
      if (!value) {
        return toast.error("End date cannot be empty");
      }

      const tempDate = new Date(value);
      if (isNaN(tempDate.getTime())) {
        return toast.error("Invalid end date");
      }

      if (
        sessionData.startdate &&
        sessionData.startdate > tempDate.toISOString().split("T")[0]
      ) {
        return toast.error("End date must be greater than start date");
      }

      setSessionData((prevSessionData) => ({
        ...prevSessionData,
        [name]: value,
        isChange : true,
      }));

    } else if (name === "startdate") {
      if (!value) {
        return toast.error("Start date cannot be empty");
      }

      const startDate = new Date(value);
      if (isNaN(startDate.getTime())) {
        return toast.error("Invalid start date");
      }

      const calculatedEndDate = new Date(startDate);
      calculatedEndDate.setFullYear(calculatedEndDate.getFullYear() + 1);
      calculatedEndDate.setDate(calculatedEndDate.getDate() - 1);

      setSessionData((prevSessionData) => ({
        ...prevSessionData,
        startdate: value,
        enddate: calculatedEndDate.toISOString().split("T")[0],
        isChange : true,
      }));
    } else {
      setSessionData((prevSessionData) => ({
        ...prevSessionData,
        [name]: value,
        isChange : true,
      }));
    }
  };

  const handleSubmit = async () => {
      if (sessionData.startdate && sessionData.enddate && sessionData.year && sessionData?.isChange) {
        try {
          let result;
          if (props.sessionData) {
            result = await schoolApi.updateSession(props.sessionData.id, sessionData);
          } else {
            result = await schoolApi.createSession(sessionData);
          }

          if (result.success) {
            toast.success(`Session ${props.sessionData ? "updated" : "created"} successfully`);
         //   fetchSessions(); 
            props.handleCloseModal();
            props.fetchAllSession();
            setSessionData({
              startdate: "",
              enddate: "",
              year: "",
              isChange : false,
            });
          }
        } catch (error) {
          if (error.response && error.response.status === 409) {
            return toast.error(error?.response?.data?.message);
          } else {
            return toast.error(error?.response?.data?.message);
          }
        }
      } else {
        if (!sessionData?.isChange) {
          props.handleCloseModal();
          props.fetchAllSession();
          setSessionData({
            startdate: "",
            enddate: "",
            year: "",
            isChange : false,
          });
        } else {
          toast.error('Missing required fiedl')
        }
      }
  };

  return (
    <Modal
      show={props.modalShow}
      centered
      className="modal-dialog-scrollable"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => {
        props.handleCloseModal();
        setSessionData({
          startdate: props.sessionData
            ? props.sessionData.startdate.split("T")[0]
            : "",
          enddate: props.sessionData
            ? props.sessionData.enddate.split("T")[0]
            : "",
          year: props.sessionData ? props.sessionData.year : "",
        });
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {props.sessionData ? "Update Session" : "Create Session"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="mt-3">
          <Row>
            <Col lg={6}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="startdate"
                  placeholder="Enter Start Date"
                  value={sessionData?.startdate || ""}
                  onChange={handleChange}
                  required
                  onKeyDown={(e) => e.preventDefault()}
                />
              </Form.Group>
            </Col>
            <Col lg={6}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="enddate"
                  placeholder="Enter End Date"
                  value={sessionData?.enddate || ""}
                  onChange={handleChange}
                  required
                  onKeyDown={(e) => e.preventDefault()}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <Form.Group className="mx-3 mt-3">
                <Form.Label className="form-view-label">Year</Form.Label>
                <Form.Control
                  type="text"
                  name="year"
                  placeholder="Enter your session year"
                  value={sessionData?.year || ""}
                  onChange={handleChange}
                  required
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleSubmit}>
          {props.btnName}
        </Button>
        <Button
          variant="light"
          onClick={() => {
            props.handleCloseModal();
            setSessionData({
              startdate: props.sessionData
                ? props.sessionData.startdate.split("T")[0]
                : "",
              enddate: props.sessionData
                ? props.sessionData.enddate.split("T")[0]
                : "",
              year: props.sessionData ? props.sessionData.year : "",
            });
          }}
        >
          Close
        </Button>
      </Modal.Footer>
      {}
    </Modal>
  );
};

export default CreateSessionModal;
